import { Component, HostListener, OnInit } from '@angular/core';
import { GlobalService } from '../global.service';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray, AbstractControl } from '@angular/forms';
import { ApiService } from '../api.service';
import { MatStepper } from '@angular/material/stepper';
import { baseUrls } from '../appConstant';
import { Router } from '@angular/router';
import { DiscountService } from '../discount.service';
import { AddressService } from '../service/address.service';
import { exit } from 'process';
declare var $;


@Component({
  selector: 'app-checkoutform',
  templateUrl: './checkoutform.component.html',
  styleUrls: ['./checkoutform.component.scss']
})
export class CheckoutformComponent implements OnInit {
  public selectedIndex = 0;
  public logstatus: any;
  confirmpass = true;
  public travellerdetails = [];
  public cartdata: any;
  public totalamount = 0;
  imagelink = baseUrls['images'];
  traveladdons = 0.00;
  addonchecklocal = false;
  addoncartid = [];
  subtotal = 0;
  mode: string;
  loginForm: FormGroup;
  billing: FormGroup;
  wrongPassword: string = '';
  submitted: boolean;
  responseData: any = {};
  errorMsg: string = '';
  public registerFormUser: FormGroup;
  errorMessageEmail: any;
  resMsg: any;
  condMsg: any;
  macro: any;
  savedCards: any;
  cardid = '0';
  travellerDataFromAPi: any;
  totaltraveller: any;
  singleprogramperson = [];
  public showAlert: boolean = false;
  public responseMessages: string = "";
  public payData: object = {};
  public year = ['2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030'];
  public month = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
  public countryList: any = [];
  public cartaddonsdata = [];
  public passerr2;
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.globalService.isBrowser) {
      // console.log(event);
      $('.slick-next:eq(0)').click(function () {
        // console.log($('.slick-list:eq(1)').css('height', $('.slick-active')[1].offsetHeight + 'px'));
      });
    }
  }
  constructor(private globalService: GlobalService, public formBuilder: FormBuilder, public httpService: ApiService, public router: Router,
    private discountService: DiscountService,
    private addressService: AddressService) {


  }

  loyalityPointsOfLoggedInUser;
  countryNameSelectedForShippingFromLocalStorage;
  tz = Intl.DateTimeFormat()?.resolvedOptions()?.timeZone ? Intl.DateTimeFormat()?.resolvedOptions()?.timeZone : "America/New_York";
  shopProductIncludeInCartData = false;
  ngOnInit(): void {
    this.logstatus = this.globalService.isLoggedIn;

    if (this.globalService.isBrowser) {

      if (this.globalService?.isLoggedIn) {
        if (localStorage.getItem('countryNameSelectedForShipping')) {
          this.countryNameSelectedForShippingFromLocalStorage = localStorage.getItem('countryNameSelectedForShipping');
        }
        this.selectedIndex = 1;
        this.mode = 'indeterminate';
        let Url = "checkout";
        const headerDict = {
          token: localStorage.getItem('userToken')
        };
        this.httpService.postFormDataBilling(Url, {}, headerDict).subscribe(response => {
          // console.log('ngOnInit_postFormDataBilling',response);
          this.loyalityPointsOfLoggedInUser = response.loyalityPoints;
          this.macro = response.macro;
          this.savedCards = response.cardData;
          if (this.macro?.payment) {
            this.billing = this.formBuilder.group({
              holdername: ['', [Validators.minLength(3), Validators.required]],
              address: ['', Validators.required],
              zipcode: ['', Validators.required],
              country: [null, [Validators.required, Validators.min(1)]],
              city: [null, Validators.required],
              state: [null, Validators.required],
              // cardno: ['', [Validators.required, Validators.minLength(12), Validators.maxLength(20),Validators.pattern("^[0-9]*$")]],
              // expiryMonth: [null, Validators.required],
              // expiryYear: [null, Validators.required],
              // cvv: ['', [Validators.required, Validators.maxLength(3), Validators.minLength(3),Validators.pattern("^[0-9]*$")]],
              // contactNumber: ['', Validators.required]
            });

            // to initiate shipping form too
            this.initiateShippingForm();

            let url = 'global/country';
            this.httpService.getData(url).subscribe((res) => {
              if (res && res['countryRecord']) {
                this.countryList = res['countryRecord'];
                // setting up country in billing for if exist in local storage
                if (localStorage.getItem('countryNameSelectedForShipping')) {
                  setTimeout(() => {
                    this.billing?.patchValue({
                      country: localStorage.getItem('countryNameSelectedForShipping').toString()
                    })
                    this.countryChangeInBillingForm({ target: { value: localStorage.getItem("countryNameSelectedForShipping")?.toString() } });

                  }, 1000);

                }
              }
            });
            // console.log(this.billing.value);
          }
          if (response.travalData?.data) {
            this.travellerDataFromAPi = response.travalData.data;
            // console.log('ngOnInit_travellerDataFromAPi', this.travellerDataFromAPi);
            this.totaltraveller = this.travellerDataFromAPi.length;
            let index = 0;
            // console.log('ngOnInit_singleprogramperson1', response.travalData.data);
            response.travalData.data.forEach(el => {
              // console.log('forEach', el ,el.itineraryData.people);
              this.singleprogramperson[index++] = [el.itineraryData.people];
            });
          }
          // console.log('ngOnInit_singleprogramperson',this.singleprogramperson);
          this.mode = 'determinate';
          setTimeout(() => {
            this.hideextra();
          }, 300);
        });

        this.getcartsummary();

        this.loginForm = this.formBuilder.group({
          email: [localStorage.getItem("userEmail") || "", Validators.required],
          password: [localStorage.getItem("userPass") || "", Validators.required],
        });
        this.registerFormUser = this.formBuilder.group({
          firstName: ["", [Validators.minLength(3), Validators.required]],
          lastName: ["", [Validators.minLength(3), Validators.required]],
          password: ["", Validators.required],
          conpassword: ["", Validators.required],
          // mobile: ["", Validators.required],
          email: ["", [Validators.required, Validators.email, this.emailDomainValidator.bind(this)]],
          timezone: [this.tz, Validators.required],
          signUpFrom: "landingPage"
        });

      }
      else {
        if (localStorage.getItem('countryNameSelectedForShipping')) {
          this.countryNameSelectedForShippingFromLocalStorage = localStorage.getItem('countryNameSelectedForShipping');
        }
        this.loginForm = this.formBuilder.group({
          email: [localStorage.getItem("userEmail") || "", Validators.required],
          password: [localStorage.getItem("userPass") || "", Validators.required],
        });
        this.registerFormUser = this.formBuilder.group({
          firstName: ["", [Validators.minLength(3), Validators.required]],
          lastName: ["", [Validators.minLength(3), Validators.required]],
          password: ["", Validators.required],
          conpassword: ["", Validators.required],
          // mobile: ["", Validators.required],
          email: ["", [Validators.required, Validators.email, this.emailDomainValidator.bind(this)]],
          // subscriptionId: ['5f211a5ac2b8533dba508234'],
          timezone: [this.tz, Validators.required],
          signUpFrom: "landingPage"
        });

        this.macro = {
          addons: true,
          orderSummry: true,
          payment: true,
          travelerDetailsPage: true,
        };
        this.billing = this.formBuilder.group({
          holdername: ['', [Validators.minLength(3), Validators.required]],
          address: ['', Validators.required],
          zipcode: ['', Validators.required],
          country: [null, [Validators.required, Validators.min(1)]],
          city: [null, Validators.required],
          state: [null, Validators.required],
          cardno: ['', [Validators.required, Validators.minLength(12), Validators.minLength(20)]],
          expiryMonth: [null, Validators.required],
          expiryYear: [null, Validators.required],
          cvv: ['', [Validators.required, Validators.maxLength(3), Validators.minLength(3)]],
          contactNumber: ['', Validators.required]
        });
        // to initiate shipping form too
        this.initiateShippingForm();
        // this.macro = {
        //   travelerDetailsPage: true,
        //   addons: true,
        //   orderSummry: true,
        //   payment: true
        // };


      }
      // this.setCarousel();
      // add Trip
      setTimeout(() => {
        let previousButton = document.getElementsByClassName("slick-prev slick-arrow");
        if (previousButton && previousButton[0]) {
          previousButton[0].textContent = "Previous Trip"
        }
        let nextButton = document.getElementsByClassName("slick-next slick-arrow");
        if (nextButton && nextButton[0]) {
          nextButton[0].textContent = "Next Trip"
        }
      }, 5000);

    }


  }

  get formData() {
    return this.registerFormUser.controls;
  }

  public keyUp(event): void {
    if (this.submitted && event.target.value.length == 0) {
      this.wrongPassword = '';
      this.responseData.message = '';
    }
  }

  public chekNumber(evt) {
    if (evt.which < 48 || evt.which > 57) {
      evt.preventDefault();
    }
  }
  get signinFormData() {
    return this.loginForm.controls;
  }

  selectionChange($event) {
    this.selectedIndex = $event.selectedIndex;
    // console.log('selectionChange',$event);
    // if (this.logstatus === true){
    //   this.setCarousel();
    // }


  }

  check($event) {
    // console.log('check',$event);
  }

  get bill() {
    return this.billing.controls;
  }

  onSubmit() {
    if (!this.globalService.isLoggedIn) {
      this.submitted = true;
      if (this.loginForm.invalid) {
        return;
      } else {
        let data = { email: this.loginForm.value.email, password: this.loginForm.value.password, type: 'normal' };
        if (this.globalService.isBrowser) {
          let url = "user/login";
          localStorage.setItem("userEmail", this.loginForm.value.email);
          localStorage.setItem("userPass", this.loginForm.value.password);
          this.mode = 'indeterminate';
          this.httpService.postFormDataBase(url, data).subscribe(response => {
            if (response.success) {
              this.globalService.isLoggedIn = true;
              response['data']['siteUrl'] = response['siteUrl'];

              localStorage.setItem('userDetails', JSON.stringify(response['data']));
              localStorage.setItem('userToken', response['token']);
              this.globalService.userDetails = JSON.parse(JSON.stringify(response['data']));
              this.getUserCurrentPlan();
              if (JSON.parse(localStorage.getItem('cartdata')) !== null) {
                let datum = [];
                var a = [];
                a = JSON.parse(localStorage.getItem('cartdata'));
                a.forEach(el => {
                  if (el?.type == "shop") {
                    let objForCart = {
                      pay: "fullamount",
                      productId: el?.productId,
                      type: "shop",
                      productInfo: el?.productInfo,
                      attr: el?.attr
                    }
                    datum.push(objForCart);
                  }
                  else {
                    let date = el?.date?.split('-');
                    let dat = {
                      type: el.portal,
                      productId: el.programId,
                      productInfo: {
                        bookingStartDate: date && date[0] ? date[0] : new Date(),
                        bookingEndDate: date && date[1] ? date[1] : new Date(),
                        accommodationId: el.accommodationId,
                        noOfPeople: el.people,
                        addonsId: el.totalAddonsId,
                      },
                      pay: el.payStatus
                    };
                    datum.push(dat);
                  }
                });
                const headerDict = {
                  token: localStorage.getItem('userToken')
                };
                let newdatum = { data: datum };

                let Url = "cartservice/create";
                this.httpService.postFormDataBilling(Url, newdatum, headerDict).subscribe(response1 => {
                  console.log('onSubmit_cartservice/create', response1);
                  localStorage.removeItem('cartdata');
                  localStorage.setItem('cartquantity', String(response1.count - 1));
                  this.globalService.cartquantity = Number(response1.count);
                  this.submitted = false;
                  this.loginForm.reset();
                  this.mode = 'indeterminate';
                  setTimeout(() => {
                    this.loginForm.reset();
                    location.reload();
                  }, 100);
                });
              } else {
                this.globalService.cartquantity = Number(response.count);
                localStorage.setItem('cartquantity', String(this.globalService.cartquantity - 1));
                this.submitted = false;
                this.loginForm.reset();
                this.mode = 'indeterminate';
                setTimeout(() => {
                  location.reload();
                }, 100);
              }




              this.mode = 'determinate';
            } else {
              this.mode = 'determinate';
              if (response['statusCode'] == '03') {
                this.errorMsg = response['message'];
              } else {
                this.wrongPassword = response['message'];
              }
            }
          });
        }
      }
    }
  }
  onSubmitUserForm() {
    if (this.globalService.isBrowser) {
      this.errorMessageEmail = '';
      this.condMsg = '';
      this.submitted = true;
      if (this.registerFormUser.invalid || !this.confirmpass || !this.checkpasswordvalid(this.registerFormUser.value.password)) {
        return;
      } else {
        let url = "user/signup";
        this.mode = 'indeterminate';
        this.httpService.postFormDataBase(url, this.toFormData(this.registerFormUser.value)).subscribe((response: any) => {
          // this.submitted = false;
          if (response.success) {
            this.resMsg = response.message;
            let data = { email: this.registerFormUser.value.email, password: this.registerFormUser.value.password, type: 'normal' };
            let url = "user/login";
            localStorage.setItem("userEmail", this.registerFormUser.value.email);
            localStorage.setItem("userPass", this.registerFormUser.value.password);
            this.httpService.postFormDataBase(url, data).subscribe(response => {
              if (response.success) {
                this.globalService.isLoggedIn = true;
                response['data']['siteUrl'] = response['siteUrl'];

                localStorage.setItem('userDetails', JSON.stringify(response['data']));
                localStorage.setItem('userToken', response['token']);
                this.globalService.userDetails = JSON.parse(JSON.stringify(response['data']));
                if (JSON.parse(localStorage.getItem('cartdata')) !== null) {
                  let datum = [];
                  var a = [];
                  a = JSON.parse(localStorage.getItem('cartdata'));
                  a.forEach(el => {
                    if (el?.type == "shop") {
                      let objForCart = {
                        pay: "fullamount",
                        productId: el?.productId,
                        type: "shop",
                        productInfo: el?.productInfo,
                        attr: el?.attr
                      }
                      datum.push(objForCart);
                    }
                    else {
                      let date = el?.date?.split('-');
                      let dat = {
                        type: el.portal,
                        productId: el.programId,
                        productInfo: {
                          bookingStartDate: date && date[0] ? date[0] : new Date(),
                          bookingEndDate: date && date[1] ? date[1] : new Date(),
                          accommodationId: el.accommodationId,
                          noOfPeople: el.people,
                          addonsId: el.totalAddonsId,
                        },
                        pay: el.payStatus
                      };
                      datum.push(dat);
                    }
                  });
                  const headerDict = {
                    token: localStorage.getItem('userToken')
                  };
                  let newdatum = { data: datum };

                  let Url = "cartservice/create";
                  this.httpService.postFormDataBilling(Url, newdatum, headerDict).subscribe(response1 => {
                    // console.log('onSubmitUserForm_2',response1);
                    localStorage.removeItem('cartdata');
                    localStorage.setItem('cartquantity', String(response.count - 1));
                    this.globalService.cartquantity = Number(response.count);
                    this.mode = 'determinate';
                    setTimeout(() => {
                      this.submitted = false;
                      this.loginForm.reset();
                      location.reload();
                    }, 100);
                  });
                } else {
                  localStorage.setItem('cartquantity', String(response.count - 1));
                  this.globalService.cartquantity = Number(response.count);
                  this.submitted = false;
                  this.loginForm.reset();
                  this.mode = 'determinate';
                  setTimeout(() => {
                    location.reload();
                  }, 100);
                }
                // this.loginForm.reset();
                // this.globalServices.viewcontainerhelper.clear();
              } else {
                this.mode = 'determinate';
                // if (response['statusCode'] == '01') {
                //   this.errorMsg = response['message'];
                // } 
                // else {
                //   this.wrongPassword = response['message'];
                // }
              }
              this.mode = 'determinate';
            });
          }
          else {
            if (response['statusCode'] == "01") {
              this.errorMessageEmail = response['message'];
            }
          }
          this.mode = 'determinate';
        });

      }
    }
  }

  toFormData<T>(formValue: T) {
    const formData = new FormData();
    for (const key of Object.keys(formValue)) {
      const value = formValue[key];
      formData.append(key, value);
    }
    return formData;
  }

  hideextra() {
    // console.log('hideextra', this.travellerDataFromAPi, this.travellerDataFromAPi?.length);
    let length = this.travellerDataFromAPi?.length;
    for (let i = 0; i < length; i++) {
      for (let k = 0; k < this.singleprogramperson[i].length; k++) {
        if (k === 0) {

        } else {
          // console.log('#form_' + i + '_' + k);
          // console.log($('#form_' + i + '_' + k).css('display', 'none'));
        }
      }
    }
    setTimeout(() => {
      this.setCarousel();
    }, 100);
  }
  public travelCount: number = 1;
  addPeople(travelno: any) {
    this.travelCount = this.travelCount + 1;
    $('.slick-list:eq(1)').css('height', ($('.slick-active')[1].offsetHeight * this.travelCount) + 'px')
    let flag = true;
    let length = this.travellerDataFromAPi.length;
    for (let i = 0; i < length; i++) {
      for (let k = 0; k < this.singleprogramperson[i].length; k++) {
        if (k !== 0) {
          if ($('#form_' + travelno + '_' + k).css('display') === 'none' && flag === true) {
            $('#form_' + travelno + '_' + k).css('display', 'block');
            flag = false;
          }
        }
      }
    }
    // this.setCarousel();
  }

  public nameMessage: string = '';
  public ageMessage: string = '';
  public emailMessage: string = '';
  public mobileMessage: string = '';
  public address1Message: string = '';
  public stateMessage: string = '';
  public zipMessage: string = '';
  public cityMessage: string = '';
  public countryMessage: string = '';
  checkforalltravellerdata(stepper: MatStepper) {
    let index = 0;
    let totaldatano = 0;
    let submitteddatano = 0;
    this.travellerdetails = [];
    let dat = {};
    this.travellerDataFromAPi?.forEach(el => {
      // console.log(el);
      let kindex = 0;
      for (let jk = 0; jk < this.singleprogramperson[index].length; jk++) {
        if (jk > 0) {
          $('#form_' + index + '_' + kindex).find('.error-dynamic' + jk).removeClass('error-dynamic' + jk);
        }
        if ($('#form_' + index + '_' + kindex).length && $('#form_' + index + '_' + kindex).css('display') !== 'none') {
          // console.log('inside');
          if (this.checkforvalue(index, kindex)) {
            dat = {
              id: el._id,
              name: $('#name_' + index + '_' + kindex)[0].value,
              age: $('#age_' + index + '_' + kindex)[0].value,
              email: $('#email_' + index + '_' + kindex)[0].value,
              mobile: $('#mobile_' + index + '_' + kindex)[0].value,
              address1: $('#address1_' + index + '_' + kindex)[0].value,
              state: $('#state_' + index + '_' + kindex)[0].value,
              zip: $('#zip_' + index + '_' + kindex)[0].value,
              city: $('#city_' + index + '_' + kindex)[0].value,
              country: $('#country_' + index + '_' + kindex)[0].value,
              // address2: $('#address2_' + index + '_' + kindex)[0].value,
            };
            this.travellerdetails.push(dat);
            submitteddatano = submitteddatano + 1;
          }
          totaldatano = totaldatano + 1;
        }
        kindex = kindex + 1;
      }
      index = index + 1;
    });
    for (let i = 0; i < totaldatano; i++) {
      this.nameMessage = '';
      this.ageMessage = '';
      this.emailMessage = '';
      this.mobileMessage = '';
      this.address1Message = '';
      this.stateMessage = '';
      this.zipMessage = '';
      this.cityMessage = '';
      this.countryMessage = '';
      $('#error-dynamic1' + i).html(this.nameMessage)
      $('#error-dynamic2' + i).html(this.ageMessage)
      $('#error-dynamic3' + i).html(this.emailMessage)
      $('#error-dynamic4' + i).html(this.mobileMessage)
      $('#error-dynamic5' + i).html(this.address1Message)
      $('#error-dynamic6' + i).html(this.stateMessage)
      $('#error-dynamic7' + i).html(this.zipMessage)
      $('#error-dynamic8' + i).html(this.cityMessage)
      $('#error-dynamic9' + i).html(this.countryMessage)
    }
    if (submitteddatano === totaldatano) {

      stepper.next();
    } else {
      for (let i = 0; i < totaldatano; i++) {
        if ($('#name_' + i + '_' + 0).val()) {
          this.nameMessage = ' ';
          $('#error-dynamic1' + i).html(this.nameMessage)
        } else {
          this.nameMessage = 'Please enter the Name';
          $('#error-dynamic1' + i).html('<span>' + this.nameMessage + '</span>');

        }
        if ($('#age_' + i + '_' + 0).val()) {
          this.ageMessage = ' ';
          $('#error-dynamic2' + i).html(this.ageMessage)
        } else {
          this.ageMessage = 'Please enter the age';
          $('#error-dynamic2' + i).html('<span>' + this.ageMessage + '</span>');
        }


        var email = $('#email_' + i + '_' + 0).val();
        if (email && email.indexOf('@') > -1 && email.indexOf('.') > -1) {
          this.emailMessage = ' ';
          $('#error-dynamic3' + i).html(this.emailMessage)
        } else {
          this.emailMessage = 'Please enter your email address in the format yourname@example.com';
          $('#error-dynamic3' + i).html('<span>' + this.emailMessage + '</span>');
        }

        if ($('#mobile_' + i + '_' + 0).val()) {

          this.mobileMessage = ' ';
          $('#error-dynamic4' + i).html(this.mobileMessage)
        } else {
          this.mobileMessage = 'Please enter the Mobile';

          $('#error-dynamic4' + i).html('<span>' + this.mobileMessage + '</span>');
        }




        if ($('#address1_' + i + '_' + 0).val()) {
          this.address1Message = ' ';
          $('#error-dynamic5' + i).html(this.address1Message)
        } else {
          this.address1Message = 'Please enter the address';

          $('#error-dynamic5' + i).html('<span>' + this.address1Message + '</span>');
        }



        if ($('#state_' + i + '_' + 0).val()) {
          this.stateMessage = ' ';
          $('#error-dynamic6' + i).html(this.stateMessage)
        } else {
          this.stateMessage = 'Please enter the state';

          $('#error-dynamic6' + i).html('<span>' + this.stateMessage + '</span>');
        }


        if ($('#zip_' + i + '_' + 0).val()) {
          this.zipMessage = ' ';
          $('#error-dynamic7' + i).html(this.zipMessage)
        } else {
          this.zipMessage = 'Please enter the zip code';

          $('#error-dynamic7' + i).html('<span>' + this.zipMessage + '</span>');
        }


        if ($('#city_' + i + '_' + 0).val()) {
          this.cityMessage = ' ';
          $('#error-dynamic8' + i).html(this.cityMessage)
        } else {
          this.cityMessage = 'Please enter city';

          $('#error-dynamic8' + i).html('<span>' + this.cityMessage + '</span>');
        }


        if ($('#country_' + i + '_' + 0).val()) {
          this.countryMessage = ' ';
          $('#error-dynamic9' + i).html(this.countryMessage)
        } else {
          this.countryMessage = 'Please enter country';

          $('#error-dynamic9' + i).html('<span>' + this.countryMessage + '</span>');
        }
      }

      // this.responseMessage = 'Please submit atleast one Traveller data for each of the Travel Programs and/or check email addresses entered!';
      // this.showAlert = true;
    }
    // console.log(submitteddatano, totaldatano);
    // console.log(this.travellerdetails);

  }

  checkforvalue(i, j) {
    if (j === 0) {
      if (($('#name_' + i + '_' + j).length && $('#age_' + i + '_' + j).length && $('#mobile_' + i + '_' + j).length && $('#email_' + i + '_' + j).length && $('#address1_' + i + '_' + j).length && $('#country_' + i + '_' + j).length && $('#city_' + i + '_' + j).length && $('#zip_' + i + '_' + j).length && $('#state_' + i + '_' + j).length)) {
        if ($('#name_' + i + '_' + j)[0].value !== '' && $('#age_' + i + '_' + j)[0].value !== '' && $('#mobile_' + i + '_' + j)[0].value !== '' && $('#email_' + i + '_' + j)[0].value !== '' && $('#address1_' + i + '_' + j)[0].value !== '' && $('#country_' + i + '_' + j)[0].value !== '' && $('#city_' + i + '_' + j)[0].value !== '' && $('#zip_' + i + '_' + j)[0].value !== '' && $('#state_' + i + '_' + j)[0].value !== '') {
          return this.isEmail($('#email_' + i + '_' + j)[0].value);
          // continue;
        }
      }
    } else {
      return true;
    }
    // else {
    //   if ($('#name_' + i + '_' + j).length && $('#age_' + i + '_' + j).length ) {
    //     if ($('#name_' + i + '_' + j)[0].value !== '' && $('#age_' + i + '_' + j)[0].value !== '') {
    //       return true;
    //     }
    //   }
    // }
    return false;
  }

  isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  }

  public emailDomainValidator(control: AbstractControl): { passwordValid: boolean } {
    let pass: any = control.value;
    if (pass?.includes('@') && pass?.includes('.')) {
      return null;
    } else {
      return { passwordValid: true };
    }
  }

  setCarousel() {
    $('.traveller-slider').slick({
      asNavFor: '.traveller-slider2',
      lazyLoad: 'ondemand',
      dots: false,
      // infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      centerPadding: '15px',
      centerMode: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            // centerPadding: '20px',
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
    $('.traveller-slider2').slick({
      asNavFor: '.traveller-slider',
      centerPadding: '15px',
      centerMode: true,
      arrows: false,
      dots: false,
      draggable: false,
      slidesToShow: 1,
      // adaptiveHeight: true,
    });


  }

  public triggerCloseEvent() {
    this.showAlert = false;
  }

  getcartsummary() {
    const headerDict = {
      token: localStorage.getItem('userToken')
    };
    let url = 'cartservice';
    this.mode = 'indeterminate';
    this.httpService.postFormDatabill(url, {}, headerDict).subscribe(response => {
      // console.log('getcartsummary ==>', response);
      this.cartdata = response.data;
      if (this.cartdata?.length < 1) {
        window.location.href = '/';
      }
      this.globalService.cartquantity = this.cartdata?.length;
      localStorage.setItem('cartquantity', String(this.globalService.cartquantity - 1));
      this.cartaddonsdata = [];
      if (this.cartdata) {
        this.cartdata.forEach(el => {
          this.getpayprice(el);
          this.createaddondata(el);
        });
      }
      // console.log(this.cartaddonsdata);
      this.addoncartid = [];
      this.traveladdons = 0.00;
      this.addonchecklocal = false;
      this.subtotal = 0;
      this.getSubtotal();
      this.totalamount = 0;
      this.getTotal();


      if (localStorage.getItem('countryNameSelectedForShipping')) {
        if (localStorage.getItem('countryNameSelectedForShipping') == "United States") {
          this.shippingInsideUsaFlag = true;
          this.calculateShippingForInsideUsa();
        }
        else {
          this.shippingInsideUsaFlag = false;
          this.calculateShippingForOutsideUsa();
        }

      }
      // ======== for auto apply of coupon code ========================
      this.autoApplyCoupon();
      this.mode = 'determinate';
    });
  }
  createaddondata(cartdata) {
    if (cartdata.itineraryData.totalAddonsValue > 0 && cartdata.itineraryData.addonsData.length > 0) {
      cartdata.itineraryData.addonsData.forEach(el => {
        el.programId = cartdata.cartId;
        this.cartaddonsdata.push(el);
      });
    }
  }

  getpayprice(cartdat) {
    // console.log(cartdat);
    let requiredDeposit = 0;
    let finalDeposit: any;
    if (cartdat.itineraryData.isDeposit !== undefined && cartdat.itineraryData.isDeposit === 1 && cartdat.pay !== 'fullamount') {
      if (cartdat.itineraryData.depositOption === 'flatPrice') {
        requiredDeposit = cartdat.itineraryData.depositValue;
        if (cartdat.itineraryData.addonsData && cartdat.itineraryData.addonsData.length > 0) {
          // finalDeposit = (requiredDeposit + cartdat.itineraryData.totalAddonsValue); // comment for addons by kc
          finalDeposit = (requiredDeposit);
        } else {
          finalDeposit = requiredDeposit * cartdat.itineraryData.people;
        }
      } else {
        // finalDeposit = (((cartdat.itineraryData.priceAfterDiscount + cartdat.itineraryData.totalAddonsValue) * cartdat.itineraryData.depositValue) / 100).toFixed(2); // comment for addons by kc
        finalDeposit = (((cartdat.itineraryData.priceAfterDiscount) * cartdat.itineraryData.depositValue) / 100).toFixed(2);
      }
    } else {
      if (cartdat?.type == "shop") {
        this.shopProductIncludeInCartData = true;
        finalDeposit = (Number(cartdat?.itineraryData?.priceAfterDiscount) * cartdat?.itineraryData?.quantity);
      }
      else {
        // finalDeposit = (Number(cartdat.itineraryData.priceAfterDiscount) + Number(cartdat.itineraryData.totalAddonsValue));//comment for removing addons by kc
        finalDeposit = (Number(cartdat?.itineraryData?.priceAfterDiscount));
      }
    }

    this.cartdata.forEach(el => {
      if (cartdat._id === el._id) {
        console.log("getpayprice", el.itineraryData, finalDeposit);
        el.itineraryData.totalPayPrice = finalDeposit;
        el.itineraryData.fullamount = (cartdat.itineraryData.priceAfterDiscount + cartdat.itineraryData.totalAddonsValue);
      }
    });
    // return finalDeposit;
  }

  getSubtotal() {

    if (this.cartdata && this.cartdata.length !== this.addoncartid) {
      this.cartdata.forEach(el => {
        if (el.type == "shop") {
          this.subtotal = this.subtotal + (Number(el.itineraryData.totalPayPrice));
          return;
        }
        if (!(this.addoncartid.includes(el._id))) {
          this.addoncartid.push(el._id);
          // console.log(this.addoncartid.includes(el._id));
          // this.subtotal = this.subtotal + (Number(el.itineraryData.totalPayPrice) - el.itineraryData.totalAddonsValue); // for addons by kc
          this.subtotal = this.subtotal + (Number(el.itineraryData.totalPayPrice));
          // this.traveladdons = this.traveladdons + el.itineraryData.totalAddonsValue; // for addons by kc
          this.traveladdons = this.traveladdons + el.itineraryData.totalAddonsValue * el.itineraryData.people;
        }
        // console.log(this.subtotal, ((Number(el.itineraryData.totalPayPrice)) - el.itineraryData.totalAddonsValue));
      });
      if (this.traveladdons > 0) {
        this.globalService.addonscheck = true;
      }
      // console.log('getSubtotal', this.subtotal);
    }
  }

  deletecartitemlive(id: any) {
    // console.log(id);
    let url = 'cartservice/' + id;
    this.mode = 'indeterminate';
    this.cancelPromoCode(); // on deleting any item in cart we will remove the applied promo code too !!
    this.httpService.postDeletebill(url).subscribe(response => {
      this.globalService.cartquantity = this.globalService.cartquantity - 1;
      localStorage.setItem('cartquantity', String(this.globalService.cartquantity - 1));
      // console.log(response);
      this.getcartsummary();
      this.mode = 'determinate';
      // location.reload(true);
    });
  }

  getTotal() {
    if (this.cartdata) {
      this.cartdata.forEach(el => {
        // console.log(this.totalamount,Number(el.itineraryData.totalPayPrice));
        // this.totalamount = this.totalamount + Number(el.itineraryData.totalPayPrice); // for addons change by kc
        this.totalamount = this.totalamount + Number(el.itineraryData.totalPayPrice) + el.itineraryData.totalAddonsValue * el.itineraryData.people;
      });
    }
  }

  submitPayment() {
    // console.log('cartdata==>submitPayment', this.cartdata,this.shippingAddressCheck, this.shippingFormGp?.invalid , this.shippingFormGp.value);
    // return;
    this.submitted = true;
    this.submittedshippingFormGp = true;
    if (this.shippingFormGp?.invalid && this.shippingAddressCheck) {
      this.showAlert = true;
      this.responseMessages = "Please fill all shipping info !!";
      setTimeout(() => {
        this.showAlert = false;
        this.responseMessages = "";
      }, 2000)
      return;
    }
    if (!this.shippingAddressCheck) {
      this.shippingFormGp?.patchValue({
        FirstName: this.billing.value.holdername ? this.billing.value.holdername.split()[0] : "",
        LastName: this.billing.value.holdername.split()[1] ? this.billing.value.holdername.split()[1] : "",
        Country: this.billing.value.country,
        State: this.billing.value.state || '',
        City: this.billing.value.city || '',
        Zipcode: this.billing.value.zipcode,
        ShippingAddress: this.billing.value.address,
        contactNumber: this.billing.value.contactNumber,
      })
    }
    if (this.billing.invalid) {
      return;
    }
    else {
      let itinerarydata = [];
      let index = 0;
      this.cartdata.forEach(el => {
        let addonsId = [];
        if (el.itineraryData?.addonsData?.length > 0) {
          el.itineraryData.addonsData.forEach(jk => {
            addonsId.push(jk.id);
          });
        }
        let temptraveldetails = [];
        if (this.travellerdetails) {
          this.travellerdetails.forEach(jk => {
            if (jk.id === el._id) {
              temptraveldetails.push(jk);
            }
          });
        }
        let itineraryobj = {
          accommodation: el.itineraryData.accommodation,
          accommodationId: el.itineraryData.accommodationId,
          accommodationValue: el.itineraryData.accommodationValue,
          cancellationPolicy: el.itineraryData.cancellationPolicy,
          cancellationPolicyId: el.itineraryData.cancellationPolicy ? el.itineraryData.cancellationPolicy._id : '',
          cancellationPolicyOptions: el.itineraryData.cancellationPolicyOptions,
          categoryName: el.itineraryData.categoryName,
          categorySlug: el.itineraryData.categorySlug,
          date: el.itineraryData.date,
          defaultImage: el.defaultImage,
          depositOption: el.itineraryData.depositOption,
          depositValue: el.itineraryData.depositValue,
          discountPercentage: el.itineraryData.discountPercentage,
          fullAmount: el.itineraryData.fullamount,
          groupBookingPercentage: el.itineraryData.groupBookingPercentage,
          groupBookingPersons: el.itineraryData.groupBookingPersons,
          isDeposit: el.itineraryData.isDeposit,
          isDiscount: el.itineraryData.isDiscount,
          isGroupBooking: el.itineraryData.isGroupBooking,
          basePrice: el.programPriceData?.price ? Number(el.programPriceData.price) * Number(el.itineraryData.people) : 0,
          offerOption: el.itineraryData.offerOption ? el.itineraryData.offerOption : 0,
          payPrice: el.itineraryData.totalPayPrice,
          payStatus: el.pay,
          people: el.itineraryData.people,
          // priceOption: 0,
          programId: el.itineraryData.programId,
          programName: el.itineraryData.programName,
          scheduleOption: el.itineraryData.scheduleOption !== undefined ? el.itineraryData : '',
          totalAddonsId: addonsId.join('###'),
          totalAddonsValue: el.itineraryData.totalAddonsValue,
          type: el.type,
          vendorId: el.itineraryData.vendorId,
          vendorCommission: el.itineraryData.vendorCommission,
          travelerInfo: temptraveldetails,
          travelPlanDiscount: el.itineraryData.travelPlanDiscount,
          digitalPlanDiscount: el.itineraryData.digitalPlanDiscount,
          originalAmount: el.itineraryData.originalAmount,
          // for slug
          slug: el.itineraryData.slug,
          countrySlug: el?.country?.slug,
          regionSlug: el?.region?.slug
        };
        // For shop product only -- el.attr -- will come in data
        if (el.attr) {
          itineraryobj['color'] = el?.attr?.color,
            itineraryobj['size'] = el?.attr?.size,
            itineraryobj['dimension'] = el?.attr?.dimension,
            itineraryobj['weight'] = el?.attr?.weight,
            itineraryobj['quantity'] = el?.itineraryData?.quantity,
            itineraryobj['variantId'] = el?.itineraryData?.variantId,
            itineraryobj['sku'] = el?.itineraryData?.sku,

            itineraryobj['productType'] = el?.attr?.productType,
            itineraryobj['flavour'] = el?.attr?.flavour,
            itineraryobj['colorCode'] = el?.attr?.colorCode
          // for shop products ==> shipping charge
          itineraryobj['shippingCost'] = this.shippingInsideUsaFlag ? el?.attr?.shippingInUSA : el?.attr?.shippingOutUSA
        }

        itinerarydata.push(itineraryobj);
      });
      let data = {
        // cardDetails: {
        //   cardNumber: this.billing.value.cardno,
        //   month: this.billing.value.expiryMonth,
        //   year: this.billing.value.expiryYear.substr(2),
        //   cvv: this.billing.value.cvv,
        //   cardHolderName: this.billing.value.holdername,
        //   address: this.billing.value.address,
        //   country: this.billing.value.country,
        //   city:this.billing.value.city || '',
        //   state:this.billing.value.state || '',
        //   zipcode: this.billing.value.zipcode,
        //   contactNumber: this.billing.value.contactNumber,
        //   paymentMode: this.cardid === '0' ? 'card': 'token',
        //   paymentModeId: this.cardid,
        //   isSaveCard: this.cardid === '0' ? ($('#savemycard')[0].checked === true ? 1 : 0) : 0 ,
        // },
        productDetails: {
          totalPrice: this.gettotalwithhandling(),
          totalQuantity: this.globalService.cartquantity,
          handlingFee: (this.totalamount * 0.029).toFixed(2),
          handlingFeePercentage: 2.9,
          couponCode: this.discountedAmount ? this.promoCode : '',
          couponDiscount: this.discountedAmount ? this.discountedAmount : 0,
          loyalityDiscount: this.loyalityPointsAmount ? this.loyalityPointsAmount : 0,
          usedPoints: this.previousLoyalityPoints ? this.previousLoyalityPoints : 0,
          // for shop products only 
          totalShippingPrice: this.shippingCharge ? this.shippingCharge : 0,
          // for shop only
          shippingStatus: this.shippingInsideUsaFlag ? "inside" : "outside",
          // for shop product if user select the other shipping address then only it work 
          shipping: this.shippingFormGp.value,
        },

        token: localStorage.getItem('userToken'),
        itineraryData: itinerarydata
      };
      // console.log('submitPayment', data, this.cartdata); return;
      let url = 'stripe-pay';
      this.mode = 'indeterminate';
      this.httpService.postFormData(url, data).subscribe(response => {
        this.payData = response;
        if (response.status) {
          localStorage.setItem('cartquantity', String(-1));
          this.globalService.cartquantity = 0;
          this.mode = 'determinate';
          // this.showAlert = true;
          // this.responseMessages = 'Payment Successfull!';
          // setTimeout(() => {
          localStorage.removeItem('bookingpage');
          //           this.router.navigate(['/confirmation'],
          //            {
          //             queryParams:
          //             {
          //                bookinId: this.payData['bookingId']
          //             }
          //           });
          // }, 3000);
          if (this.globalService.isBrowser) {
            return window.location.href = response.session.url
          }
        } else {
          this.mode = 'determinate';
          this.showAlert = true;
          this.responseMessages = 'Payment Failed: Please Try Again !!';
        }
      });
    }
  }

  adjustheight() {
    $('.backspinner').css('height', $(document).innerHeight() + 'px');
    return true;
  }

  gettotalwithhandling() {
    let tot: number;
    tot = parseFloat(String(this.totalamount));
    let handling: number;
    handling = parseFloat(String(tot * 0.029));
    // console.log('gettotalwithhandling', tot, handling, this.shippingCharge);
    return (tot + handling + Number(this.shippingCharge))?.toFixed(2);
  }

  deleteaddon(addonid, cartid) {
    let url = 'cartservice/' + cartid + '/' + addonid;
    this.mode = 'indeterminate';
    this.httpService.postDeletebill(url).subscribe(response => {
      // console.log(response);
      this.getcartsummary();
      this.mode = 'determinate';
    });
  }

  togglecardtick(id, cardid) {
    let flag = true;
    var checktick = document.getElementById('card_' + id);
    if (checktick.style.display !== 'none') {
      flag = true;
    } else {
      flag = false;
    }
    var elem = Array.from(document.getElementsByClassName('tickcard') as HTMLCollectionOf<HTMLElement>);
    for (var i = 0; i < elem.length; i++) {
      elem[i].style.display = 'none';
    }

    if (flag === false) {
      checktick.style.display = 'block';
      this.cardid = cardid;
      this.billing = this.formBuilder.group({
        holdername: ['', [Validators.minLength(3), Validators.required]],
        address: ['', Validators.required],
        zipcode: ['', Validators.required],
        country: [null, [Validators.required, Validators.min(1)]],
        city: [null, Validators.required],
        state: [null, Validators.required],
        cvv: ['', [Validators.required, Validators.maxLength(3), Validators.minLength(3)]],
      });
    } else {
      this.cardid = '0';
      this.billing = this.formBuilder.group({
        holdername: ['', [Validators.minLength(3), Validators.required]],
        address: ['', Validators.required],
        zipcode: ['', Validators.required],
        country: [null, [Validators.required, Validators.min(1)]],
        city: [null, Validators.required],
        state: [null, Validators.required],
        cardno: ['', [Validators.required, Validators.minLength(12), Validators.maxLength(20)]],
        expiryMonth: [null, Validators.required],
        expiryYear: [null, Validators.required],
        cvv: ['', [Validators.required, Validators.maxLength(3), Validators.minLength(3)]],
      });
    }
  }

  checkpasswordvalid(str) {
    if (str !== '') {
      // console.log(str);
      // var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
      var re = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[a-zA-Z!#$%@_^&? "])[a-zA-Z0-9!#$%@_^&?]{6,}$/;
      // console.log(re.test(str));
      if (!re.test(str)) {
        this.passerr2 = "Atleast 1 Digit, 1 UpperCase and 1 special Character is required.";
      } else {
        this.passerr2 = '';
      }

      return re.test(str);
    } else {
      this.passerr2 = '';
    }
  }

  checkpassword() {
    if (this.globalService.isBrowser) {
      if ($('#pass')[0].value === $('#confirmpass')[0].value && $('#confirmpass')[0].value !== '') {
        this.confirmpass = true;
      } else if ($('#confirmpass')[0].value === '') {
        this.confirmpass = true;
      } else {
        this.confirmpass = false;
      }
    }
  }

  urlvideo(imagestring) {
    if ((typeof imagestring) == 'string') {
      return imagestring.includes('https');
    } else {
      return false;
    }
  }

  promoCode: string;
  previousPromoCode: string;
  messageForPromoCode: string;
  showMessageForPromoCode: boolean = false;
  discountedAmount: number;
  previousSubtotalAmount: number;
  previousTotalAmount: number;
  couponInfo;
  ContinueWithPromoCode() {
    // console.log('ContinueWithPromoCode', this.promoCode);
    if (this.promoCode) {
      // if(this.messageForPromoCode == "Coupon is Expired" || this.messageForPromoCode == "Coupon in not valid"){
      //   this.showMessageForPromoCode = true;
      //   // this.messageForPromoCode = 'Coupon is Expired'; 
      //   setTimeout(() => {
      //    this.showMessageForPromoCode = false;
      //   }, 3000)
      // }
      if (this.promoCode == this.previousPromoCode) {
        // console.log('ContinueWithPromoCode_3_if', this.promoCode == this.previousPromoCode, this.promoCode, this.previousPromoCode);
        this.showMessageForPromoCode = true;
        // this.messageForPromoCode = 'Already applied !!'; 
        setTimeout(() => {
          this.showMessageForPromoCode = false;
        }, 3000)
      }
      if (this.promoCode !== this.previousPromoCode) {
        this.previousPromoCode = this.promoCode;
        let reqDataArray = [];
        this.cartdata?.forEach((obj: any) => {
          // console.log("ContinueWithPromoCode_2", obj);
          if (obj.type === 'travel') {
            reqDataArray.push({
              subscriptionCategoryId: "",
              subscriptionId: obj._id,
              originalAmount: obj?.itineraryData?.priceAfterDiscount + (obj?.itineraryData?.totalAddonsValue * obj?.itineraryData?.people),
              subscriptionName: "",
              subscriptionCategoryName: "",
              isTrialUsed: 1,
              isTrial: 0
            });

          }
          if (obj.type === 'shop') {
            reqDataArray.push({
              subscriptionCategoryId: obj?.subscriptionCategoryId,
              subscriptionId: obj._id,
              originalAmount: (obj?.itineraryData?.priceAfterDiscount + (obj?.itineraryData?.totalAddonsValue * obj?.itineraryData?.people)) * obj?.itineraryData?.quantity,
              subscriptionName: obj?.itineraryData?.programName,
              subscriptionCategoryName: "",
              isTrialUsed: 1,
              isTrial: 0,
              productId: obj?.itineraryData?.programId,
              vendorId: obj?.itineraryData?.vendorId,
              type: "shopWell",
            });

          }
          else {
            reqDataArray.push({
              subscriptionCategoryId: "",
              subscriptionId: obj._id,
              originalAmount: obj.originalAmount,
              subscriptionName: "",
              subscriptionCategoryName: "",
              isTrialUsed: 1,
              isTrial: 0
            });
          }
        })
        let objToSend = { couponCode: this.promoCode, reqData: reqDataArray };
        // console.log('ContinueWithPromoCode_2', objToSend);
        // return;
        this.discountService.promotionalOrLoyalityPointsDiscount('coupon/api/apply', objToSend).subscribe((resOfPromotionalCouponApplied: any) => {
          if (resOfPromotionalCouponApplied) {
            // console.log('resOfPromotionalCouponApplied', resOfPromotionalCouponApplied);
            this.discountedAmount = resOfPromotionalCouponApplied.globalDiscount.discount;
            // this.previousSubtotalAmount = this.subtotal;
            this.previousTotalAmount = this.totalamount;
            this.totalamount = this.totalamount - resOfPromotionalCouponApplied.globalDiscount.discount;
            this.showMessageForPromoCode = true;
            this.couponInfo = resOfPromotionalCouponApplied;
            this.messageForPromoCode = resOfPromotionalCouponApplied.status;
            setTimeout(() => {
              this.showMessageForPromoCode = false;
            }, 3000)
          }
        })
      }

    }
    else {
      this.showMessageForPromoCode = true;
      this.messageForPromoCode = 'Please enter some promotional code';
      setTimeout(() => {
        this.showMessageForPromoCode = false;
      }, 2000)
    }
  }

  cancelPromoCode() {
    // if(this.previousSubtotalAmount){
    //   this.subtotal = this.previousSubtotalAmount;
    // }
    if (this.discountedAmount) {
      this.totalamount = this.totalamount + this.discountedAmount;
      this.promoCode = undefined;
      this.previousPromoCode = undefined;
      this.discountedAmount = undefined;
    }
    else {
      this.promoCode = undefined;
      // this.previousPromoCode = undefined;
    }
  }

  loyalityPoints;
  previousLoyalityPoints;
  showMessageForLoyalityPoints: boolean = false;
  messageForLoyalityPoints: string;
  loyalityPointsAmount: number;
  ContinueWithLoyalityPoints() {
    // console.log('ContinueWithPromoCode', this.promoCode);
    if (this.loyalityPoints) {
      if (this.loyalityPointsOfLoggedInUser > 0) {
        if (this.loyalityPointsOfLoggedInUser >= this.loyalityPoints) {
          if (this.loyalityPoints !== this.previousLoyalityPoints) {
            let objToSend = { usedPoints: this.loyalityPoints };
            this.discountService.promotionalOrLoyalityPointsDiscount('loyalityPoint/apply', objToSend).subscribe((resOfLoyalityPointApplied: any) => {
              if (resOfLoyalityPointApplied.status == true && resOfLoyalityPointApplied.payByPoints) {
                // console.log('resOfPromotionalCouponApplied', resOfLoyalityPointApplied);
                this.previousLoyalityPoints = this.loyalityPoints;
                this.loyalityPointsAmount = resOfLoyalityPointApplied.payByPoints;
                this.previousTotalAmount = this.totalamount;
                this.totalamount = this.totalamount - resOfLoyalityPointApplied.payByPoints;
                this.showMessageForLoyalityPoints = true;
                this.messageForLoyalityPoints = resOfLoyalityPointApplied.status ? 'Applied' : 'Not Applied';
                setTimeout(() => {
                  this.showMessageForLoyalityPoints = false;
                }, 2000)
              }
            })
          } else {
            this.showMessageForLoyalityPoints = true;
            this.messageForLoyalityPoints = 'Already entered !!';
            setTimeout(() => {
              this.showMessageForLoyalityPoints = false;
            }, 2000)
          }
        } else {
          this.showMessageForLoyalityPoints = true;
          this.messageForLoyalityPoints = 'Maximum loyality points used is ' + this.loyalityPointsOfLoggedInUser;
          setTimeout(() => {
            this.showMessageForLoyalityPoints = false;
          }, 2000)
        }
      } else {
        this.showMessageForLoyalityPoints = true;
        this.messageForLoyalityPoints = 'No loyality points found !';
        setTimeout(() => {
          this.showMessageForLoyalityPoints = false;
        }, 2000)
      }

    } else {
      this.showMessageForLoyalityPoints = true;
      this.messageForLoyalityPoints = 'Please enter some loyality point !';
      setTimeout(() => {
        this.showMessageForLoyalityPoints = false;
      }, 2000)
    }
  }

  cancelLoyalityPoints() {
    if (this.loyalityPointsAmount) {
      this.totalamount = this.totalamount + this.loyalityPointsAmount;
      this.loyalityPoints = undefined;
      this.previousLoyalityPoints = undefined;
      this.loyalityPointsAmount = undefined;
    }
    else {
      this.loyalityPoints = undefined;
    }
  }

  shippingInsideUsaFlag = true;
  // shippingInsideUsa(info){
  //   console.log('shippingInsideUsa', info);
  //   if(info == 'YES'){
  //     this.shippingInsideUsaFlag = true;
  //     this.calculateShippingForInsideUsa();
  //   }
  //   if(info == 'NO'){
  //     this.shippingInsideUsaFlag = false;
  //     this.calculateShippingForOutsideUsa();
  //   }
  // }

  shippingAddressCheck;
  openShippingAddressPopUpFlag = false;
  shippingAddressCheckCall(eventPassed) {
    console.log('shippingAddressCheckCall', eventPassed?.target?.value, this.shippingAddressCheck, this.shippingFormGp?.controls?.Country?.value);
    if (this.shippingAddressCheck && this.shippingFormGp?.controls?.Country?.value) {
      this.countryChangeInShippingForm({ target: { value: this.shippingFormGp?.controls?.Country?.value } });
    }
    else if (!this.shippingAddressCheck && this.billing?.controls?.country?.value) {
      this.countryChangeInShippingForm({ target: { value: this.billing?.controls?.country?.value } });
    }
  }

  shippingFormGp: FormGroup;
  submittedshippingFormGp = false;
  initiateShippingForm() {
    this.shippingFormGp = this.formBuilder.group({
      FirstName: ['', Validators.required],
      LastName: ['', Validators.required],
      Country: ['', Validators.required],
      State: ['', Validators.required],
      City: ['', Validators.required],
      Zipcode: ['', Validators.required],
      ShippingAddress: ['', Validators.required],
      contactNumber: ['', Validators.required]
    });

    if (this.countryNameSelectedForShippingFromLocalStorage) {
      this.shippingFormGp?.patchValue({
        Country: this.countryNameSelectedForShippingFromLocalStorage
      })
    }
  }
  get shippingFormControls() {
    return this.shippingFormGp.controls;
  }

  shippingCharge = 0;
  calculateShippingForInsideUsa() {
    this.shippingCharge = 0;
    if (this.globalService.isLoggedIn) {
      this.cartdata?.forEach((obj: any) => {
        if (obj?.type == "shop") {
          if (obj?.attr?.shippingInUSA >= 0) {
            this.shippingCharge += Number(obj?.attr?.shippingInUSA);
            this.checkoutButtonFlag = true;
          }
          else {
            this.checkoutButtonFlag = false;//Due to shippping Not Available OutsideUsa
            return;
          }
        }
      })
    }
    else {
      this.cartdata.forEach((obj: any) => {
        if (obj?.type == "shop") {
          if (obj?.shippingInUSA >= 0) {
            this.shippingCharge += Number(obj?.shippingInUSA);
            this.checkoutButtonFlag = true;
          }
          else {
            this.checkoutButtonFlag = false;//Due to shippping Not Available Inside USA
            return;
          }
        }
      })
    }
  }
  checkoutButtonFlag = true;
  calculateShippingForOutsideUsa() {
    this.shippingCharge = 0;
    this.shippingInsideUsaFlag = false;
    if (this.globalService.isLoggedIn) {
      // console.log('calculateShippingForOutsideUsa1', this.cartdata);
      this.cartdata?.forEach((obj: any) => {
        if (obj?.type == "shop") {
          // console.log('calculateShippingForOutsideUsa1_2', obj?.attr?.shippingOutUSA);
          if (obj?.attr?.shippingOutUSA >= 0) {
            this.shippingCharge += Number(obj?.attr?.shippingOutUSA);
            this.checkoutButtonFlag = true;
          }
          else {
            this.checkoutButtonFlag = false;//Due to shippping Not Available OutsideUsa
            return;
          }
        }
      })
    }
    else {
      // console.log('calculateShippingForOutsideUsa2', this.cartdata);
      this.cartdata.forEach((obj: any) => {
        if (obj?.type == "shop") {
          // console.log('calculateShippingForOutsideUsa2_2', this.cartdata);
          if (obj?.shippingOutUSA >= 0) {
            this.shippingCharge += Number(obj?.shippingOutUSA);
            this.checkoutButtonFlag = true;
          }
          else {
            this.checkoutButtonFlag = false;//Due to shippping Not Available OutsideUsa
            return;
          }
        }
      })
    }

  }

  countryChangeInShippingForm(eventPassed) {
    // console.log('countryChangeInShippingForm', eventPassed?.target?.value );
    if (eventPassed?.target?.value === "United States") {
      this.shippingInsideUsaFlag = true;
      localStorage.setItem('countryNameSelectedForShipping', eventPassed?.target?.value);
      this.calculateShippingForInsideUsa();
    }
    else {
      this.shippingInsideUsaFlag = false;
      localStorage.setItem('countryNameSelectedForShipping', eventPassed?.target?.value);
      this.calculateShippingForOutsideUsa();
    }
  }
  countryChangeInBillingForm(eventPassed) {
    // console.log('countryChangeInBillingForm', eventPassed?.target?.value );
    if (eventPassed?.target?.value === "United States") {
      this.shippingInsideUsaFlag = true;
      localStorage.setItem('countryNameSelectedForShipping', eventPassed?.target?.value);
      this.calculateShippingForInsideUsa();
    }
    else {
      this.shippingInsideUsaFlag = false;
      localStorage.setItem('countryNameSelectedForShipping', eventPassed?.target?.value);
      this.calculateShippingForOutsideUsa();
    }
  }

  clickOnNameRoute(eventPassed) {
    // console.log('clickOnNameRoute', eventPassed);
    if (eventPassed?.itineraryData?.slug) {
      if (eventPassed?.type == "shop") {
        window.open(
          baseUrls?.hostedUrl + 'shopwell/' + 'product/' + eventPassed?.itineraryData?.slug,
          '_blank'
        );
      }
      if (eventPassed?.type == "digital-classes") {
        window.open(
          baseUrls?.hostedUrl + 'livewell/' + 'class/' + eventPassed?.itineraryData?.slug,
          '_blank'
        );
      }
      if (eventPassed?.type == "digital-programs") {
        window.open(
          baseUrls?.hostedUrl + 'livewell/' + 'program/' + eventPassed?.itineraryData?.slug,
          '_blank'
        );
      }
      if (eventPassed?.type == "onetooneclass") {
        window.open(
          baseUrls?.hostedUrl + 'livewell/onetoone',
          '_blank'
        );
      }

      if (eventPassed?.type == "travel" && eventPassed?.country?.slug && eventPassed?.region?.slug) {
        window.open(
          baseUrls?.hostedUrl + 'travel/' + 'destinations/' + eventPassed?.region?.slug + "/" + eventPassed?.country?.slug + "/" + eventPassed?.itineraryData?.categorySlug + '/' + eventPassed?.itineraryData?.slug,
          '_blank'
        );
      }

    }
  }

  shippingAddressListShowFlag = false;
  continueCheckoutClickOnOrderSummary() {
    // console.log('continueCheckoutClickOnOrderSummary', this.cartdata);
    if (this.cartdata?.length > 0) {
      this.cartdata?.forEach((obj: any) => {
        if (obj?.type == "shop" && !this.shippingAddressListShowFlag) {
          this.shippingAddressListShowFlag = true;
          this.getUserAddresses();
        }
      })
      // console.log('continueCheckoutClickOnOrderSummary', this.shippingAddressListShowFlag);
    }
  }
  addressData;
  getUserAddresses() {
    if (!this.addressData) {
      if (localStorage?.getItem('userDetails') && this.globalService?.isLoggedIn) {
        let userId = JSON.parse(localStorage?.getItem('userDetails'))?._id;
        this.addressService?.postAddressesForAddressList(0, 10, userId).subscribe((resOfAddresses: any) => {
          // console.log('getUserAddresses', resOfAddresses);
          if (resOfAddresses) {
            this.addressData = resOfAddresses;
          }
        },
          (error: any) => {
            //  console.log('===Error===>', error);
          })
      }
    }
  }
  selectedIndexForShippingAddress;
  shippingAddressSelectedFromList(shippingAddressInfo) {
    // console.log('shippingAddressSelectedFromList', shippingAddressInfo);
    if (shippingAddressInfo) {
      this.shippingFormGp?.patchValue({
        FirstName: shippingAddressInfo?.address?.FirstName,
        LastName: shippingAddressInfo?.address?.LastName,
        Country: shippingAddressInfo?.address?.Country,
        State: shippingAddressInfo?.address?.State,
        City: shippingAddressInfo?.address?.City,
        Zipcode: shippingAddressInfo?.address?.Zipcode,
        ShippingAddress: shippingAddressInfo?.address?.address
      });
    }
  }
  billingAddressCheck = false;
  billingAddressCheckCall(eventPassed) {
    this.billingAddressCheck = !this.billingAddressCheck;
    // console.log('billingAddressCheckCall', eventPassed?.target?.value, this.billingAddressCheck);
    // if(this.shippingAddressCheck && this.shippingFormGp?.controls?.Country?.value){
    //   this.countryChangeInShippingForm({target: {value : this.shippingFormGp?.controls?.Country?.value}});
    // }
    // else if(!this.shippingAddressCheck && this.billing?.controls?.country?.value){
    //   this.countryChangeInShippingForm({target: {value : this.billing?.controls?.country?.value}});
    // }
  }
  selectedIndexForBillingAddress;
  billingAddressSelectedFromList(addressInfo) {
    // console.log('billingAddressSelectedFromList', addressInfo);
    if (addressInfo) {
      this.billing?.patchValue({
        holdername: addressInfo?.address?.FirstName + " " + addressInfo?.address?.LastName,
        address: addressInfo?.address?.address,
        zipcode: addressInfo?.address?.Zipcode,
        country: addressInfo?.address?.Country,
        city: addressInfo?.address?.City,
        state: addressInfo?.address?.State,
      });
    }

  }
  countryUpdateInBillingForm() {
    console.log('countryUpdateInBillingForm', this.billing?.controls?.country?.value);
    if (this.billing?.controls?.country?.value) {
      this.countryChangeInBillingForm({ target: { value: this.billing?.controls?.country?.value } })
    }
  }
  countryUpdateInShippingForm() {
    if (this.shippingFormGp?.controls?.Country?.value) {
      this.countryChangeInShippingForm({ target: { value: this.billing?.controls?.Country?.value } })
    }
  }
  autoApplyCoupon() {
    this.discountService.getUserSubscriptionDiscount("usersubscription/discount/coupon").subscribe((resOfCouponForUserSubscription: any) => {
      // console.log('routeToCheckout_2', resOfCouponForUserSubscription);
      if (resOfCouponForUserSubscription?.couponCode) {
        this.promoCode = resOfCouponForUserSubscription?.couponCode;
        setTimeout(() => {
          this.ContinueWithPromoCode();
        }, 100);
        // console.log('routeToCheckout_3', resOfCouponForUserSubscription);
      }
    })
  }
  userCurrentPlans = [];
  getUserCurrentPlan() {
    if (this.globalService?.isLoggedIn) {
      const userId = JSON.parse(localStorage.getItem('userDetails'))?._id;
      // this.httpService.getDatabill(`billingservice/usersubscription/subs/${userId}`).subscribe((subscribePlan: any) => { //for DEV or STAGING 
      this.httpService.getDatabill(`usersubscription/subs/${userId}`).subscribe((subscribePlan: any) => { // for PROD 
        if (subscribePlan) {
          // console.log('getUserCurrentPlan', subscribePlan);
          this.userCurrentPlans = subscribePlan;
          localStorage.setItem('userSubscriptionPlan', JSON.stringify(subscribePlan))
          // 
          if (subscribePlan && subscribePlan[0]?.isExpired == 1) {
            // this.globalServices.moveToPlanPage.next(true);
            localStorage.setItem('moveToPlanPage', 'true');
          }
          else {
            // this.globalServices.moveToPlanPage.next(false);
            localStorage.setItem('moveToPlanPage', 'false');
          }
          // 
          // this.getSubscriptionPlan();
        }
      })
    }
  }
}
